<template>
	<v-tabs
		:class="`app-tabs${app ? ' app-subnav': ''}`"
		:background-color="color"
		:value="selected"
		:dark="dark"
		:vertical="vertical"
		:grow="!vertical && !app"
		:optional="app"
		show-arrows
		@change="onChange"
	>
		<v-tab
			v-for="(tab, i) in tabs"
			:key="`tab-${i}`"
			:disabled="tab.disabled"
			:href="tab.tab ? `#${tab.tab}` : null"
			:to="tab && tab.to"
			:exact="tab.exact"
		>
			{{ tab.name }}
			<v-icon v-if="tab.icon">{{ tab.icon }}</v-icon>
		</v-tab>

		<v-tab-item
			v-for="(tab, i) in tabs"
			:key="`tab-item-${i}`"
			:value="tab.value"
			:reverseTransition="tab && !tab.to ? undefined : false"
			:transition="tab && !tab.to ? undefined : false"
		>
			<slot name="tab-item" v-bind:tab="tab"></slot>
		</v-tab-item>
	</v-tabs>
</template>

<script>
// Note - if not appearing, ensure looking if value is the proper url
import Tab from '@/types/Tab'

export default {
	props: {
		app: Boolean,
		color: String,
		value: String,
		dark: Boolean,
		vertical: Boolean,
		tabs: {
			type: Array,
			default: () => [],
			validator: arr => arr.every(el => el instanceof Tab),
		},
	},
	data() {
		return {
			selected: '',
			last: null,
		}
	},
	mounted() {
		this.selected = this.value
	},
	watch: {
		value() {
			this.selected = this.value
		},
	},
	methods: {
		onChange(event) {
			// FIX - Needed this to fix swipping issue on mobile
			if (!event) {
				if (this.last) {
					/* FIX - Needed timeout to fix undefined tabs value but defined
						selected on query parameters changes as watched value won't trigger properly */
					this.selected = null
					setTimeout(() => {
						this.selected = this.last
					}, 1)
				}

				this.$emit('change', event || this.last)
				return
			}

			this.last = event
			const tab = this.tabs.find(singleTab => singleTab.value === event)
			if (tab && tab.to && event !== this.$route.path) {
				this.$router.push(tab.to)
			}

			this.$emit('change', event)
		},
	},
}
</script>

<style scoped>
	.app-tabs::v-deep > .v-tabs-items {
		background-color: inherit;
	}

	.app-tabs.app-subnav::v-deep > .v-tabs-bar {
		position: absolute;
		z-index: 2;
		left: 0;
		right: 0;
		top: 0;
	}
	.app-tabs.app-subnav::v-deep > .v-tabs-items {
		margin-top: 50px;
	}
</style>
